module.exports = __webpack_public_path__ + "img/hangtohang.7c6edf9c.jpg";